<template>
  <div class="row justify-content-center align-items-md-center">
    <div class="col-md-8">
      <div class="card full-height bg-ligth">
        <div class="card-header">
          <h3 class="mb-0">{{ lista_campos != '' ? 'Editar' : 'Criar' }} caixa</h3>
        </div>
        <div class="card-body">
          <form action="">
            <div class="form-group row">
              <div class="col-md-8">
                <label class="col-md-12">Nome:*</label>
                <input
                    required
                    type="text"
                    class="form-control"
                    v-model="form.nome"
                    placeholder="Digite o nome..."
                />
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-12">
                <label class="col-md-12">Descrição:*</label>
                <input
                    required
                    type="text"
                    class="form-control"
                    v-model="form.descricao"
                    placeholder="Digite a Descrição..."
                />
              </div>
            </div>

            <div class="form-group row">
              <div class="col-md-6">
                <label class="col-md-12">Sequencia:*</label>
                <input
                    required
                    type="text"
                    class="form-control"
                    v-model="form.sequencia"
                    placeholder="Digite a sequencia..."
                />
              </div>
              <div class="col-md-6">
                <label class="col-md-12">Hora encerramento:*</label>
                <input
                    required
                    type="time"
                    class="form-control"
                    v-model="form.hora_encerramento"
                    placeholder="Digite a hora encerramento..."
                />
              </div>
            </div>

            <div class="form-group row">
              <div class="col-md-12 text-center">
                <button
                    @click.prevent="confirm(lista_campos == '' ? 'cria' : 'edita')"
                    class="btn btn-primary"
                    :disabled="verif"
                >
                  Salvar
                  <b-spinner
                      v-show="verif"
                      small
                      variant="dark"
                      type="grow"
                      label="Spinning"
                  ></b-spinner>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {fireAlert} from "@/core/mixins/alertMessageMixin";

export default {
  mixins: [fireAlert],
  data() {
    return {
      form: {
        nome: "",
        descricao: "",
        status: 1,
        sequencia: "",
        hora_encerramento: "",
        usuario_id: 1,
      },
      verif: false,
    };
  },
  created() {
    this.preenxerCampos();
    this.listar_requerimentos();
  },
  computed: {
    lista_campos() {
      return this.$store.state.configEmpresa.lista_campos;
    },
    mensagem_alert() {
      return this.$store.state.financeiro.mensagem_alert;
    },
    lista_filials() {
      return this.$store.state.configEmpresa.lista_filials;
    },
  },
  methods: {
    async confirm(tipo) {
      await this.$confirm({
        title: "Estas seguro?",
        message: `Esta ação ` + tipo + ` un caixa no sistema?`,
        button: {
          no: "No",
          yes: "Si",
        },
        callback: (confirm) => {
          if (confirm) {
            if (tipo == "cria") this.create();
            if (tipo == "edita") this.update();
          }
        },
      });
    },
    async create() {
      this.verif = true;
      await this.$store.dispatch("financeiro/create_finan_caixa", this.form);
      this.verif = false;
      this.fireAlert({
        ...this.mensagem_alert, routeName: 'caixa'
      });
    },
    async update() {
      this.verif = true;
      await this.$store.dispatch("financeiro/update_finan_caixa", this.form);
      this.verif = false;
      this.fireAlert({
        ...this.mensagem_alert, routeName: 'caixa'
      });
    },
    preenxerCampos() {
      if (this.lista_campos != "")
        this.form = {
          id: this.lista_campos.id,
          nome: this.lista_campos.nome,
          descricao: this.lista_campos.descricao,
          hora_encerramento: this.lista_campos.hora_encerramento,
          sequencia: this.lista_campos.sequencia,
          filial_id: this.lista_campos.filial_id,
          status: this.lista_campos.status,
        };
    },
    listar_requerimentos() {
      this.$store.dispatch("configEmpresa/listar_filial");
    },
  },
};
</script>

<style scoped>
.lista:hover {
  background-color: rgba(167, 183, 255, 0.705);
}
</style>